"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";

export default function MainShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isLogin = pathname === "/login";

  return (
    <main className={isLogin ? "flex-1" : "flex-1 overflow-y-auto pt-14 md:pt-0"}>
      {children}
    </main>
  );
}
